import { useCallback, useEffect, useState } from "react";
import {
  Modal,
  IconButton,
  Button,
  Box,
  Stack,
  Typography,
  Chip,
  TextField,
  Radio,
  CircularProgress
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { BIBlue, BIGrey, BILightGrey, BIRed, lightenHexColor } from "../../assets/helpers";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Postrequestcall } from "../../request/Postrequest";
import { FETCH_JOB_POST_TYPES, SAVE_JOB_POSTS_NEW } from "../../constant/Apipath";
import { useDispatch, useSelector } from "react-redux";
import FilterListModal from "./FilterListModal";
import Divider from "@mui/material/Divider";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import EditIcon from "@mui/icons-material/Edit";
import { setChoosesite, setSelectedsite, setShowmapmodal } from "../../redux/actions/actions";
import SearchMap from "../sites/SearchMap";
import AddCompnayModal from "../common/AddCompanyModal";
import { English } from "../../constant/EnglishFallback";

// Comprehensive URL validation regex that checks for:
// - Protocol (optional http or https)
// - Valid domain name structure
// - Valid TLD (2-63 characters)
// - Valid special characters in path
// - Maximum length checks
// - No dangerous characters
const urlRegex =
  /^(?:https?:\/\/)?(?:www\.)?(?!-)[A-Za-z0-9-]{1,63}(?:\.[A-Za-z0-9-]{1,63})*\.[A-Za-z]{2,63}(?::\d{1,5})?(?:\/(?:[-\w.,@?^=%&amp;:/~+#]*[-\w@?^=%&amp;/~+#])?)?$/;

const validateUrl = (url) => {
  if (!url) return true; // Empty URL is valid as it might be optional
  if (url.length > 2048) return false; // URL too long
  if (url.includes("..")) return false; // Prevent directory traversal
  if (/[<>'"{}|\\^`]/.test(url)) return false; // Prevent unsafe characters
  return urlRegex.test(url);
};

const PostAJobModal = (props) => {
  const { open, onClose, onNewJobPostedSuccess } = props;

  const dispatch = useDispatch();
  const { loginData, chooseSite } = useSelector((state) => state?.main);
  const userID = Number(loginData?.userInformation?.UserId || 0);

  const [page, setPage] = useState(1);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");

  const [typeOptions, setTypeOptions] = useState([]);
  const [selectedTypeValue, setSelectedTypeValue] = useState("");

  const [showTradesModal, setShowTradesModal] = useState(false);
  const [selectedTrades, setSelectedTrades] = useState([]);

  const [showAdditionalInfo, setShowAdditionalInfo] = useState(true);

  const [searchTerm, setSearchTerm] = useState("");
  const [locationDetails, setLocationDetails] = useState({});

  const [selectedSite, setSelectedSite] = useState(null);
  const [showRequiredError, setShowRequiredError] = useState(false);
  const [receiveApplicationBy, setReceiveApplicationBy] = useState("email");
  const [webSiteUrl, setWebSiteUrl] = useState("");
  const [isWebisiteUrlInValid, setIsWebisiteUrlInValid] = useState(false);

  const [submitLoading, setSubmitLoading] = useState(false);
  const [showCompanyOptions, setShowCompanyOptions] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(null);

  const { multiLanguageData } = useSelector((state) => state?.main);

  const LanguageData = multiLanguageData?.JobPostings || {};

  const {
    TEXT_TITLE = English.JobPostings?.TEXT_TITLE || "Title",
    TEXT_ENTER_JOB_TITLE = English.JobPostings?.TEXT_ENTER_JOB_TITLE || "Enter job title",
    TEXT_COMPANY = English.JobPostings?.TEXT_COMPANY || "Company",
    TEXT_SELECT_COMPANY = English.JobPostings?.TEXT_SELECT_COMPANY || "Select company",
    TEXT_TYPE = English.JobPostings?.TEXT_TYPE || "Type",
    TEXT_LOCATION = English.JobPostings?.TEXT_LOCATION || "Location",
    TEXT_SEARCH_LOCATION = English.JobPostings?.TEXT_SEARCH_LOCATION || "Search location",
    TEXT_ADDITIONAL_INFORMATION = English.JobPostings?.TEXT_ADDITIONAL_INFORMATION ||
      "Additional Information",
    TEXT_ADDITIONAL_INFORMATION_DESCRIPTION = English.JobPostings?.TEXT_ADDITIONAL_INFORMATION_DESCRIPTION ,
    TEXT_WEBSITE = English.JobPostings?.TEXT_WEBSITE ,
    TEXT_RECEIVED_APPLICANTS = English.JobPostings?.TEXT_RECEIVED_APPLICANTS ,

    TEXT_SITE = English.JobPostings?.TEXT_SITE || "Site",
    TEXT_CHOOSE_SITE = English.JobPostings?.TEXT_CHOOSE_SITE || "CHOOSE SITE",
    TEXT_TRADE = English.JobPostings?.TEXT_TRADE || "Trade(s)",
    BUTTON_NEXT = English.JobPostings?.BUTTON_NEXT || "Next",
    TEXT_DESCRIPTION = English.JobPostings?.TEXT_DESCRIPTION ,
    BUTTON_PUBLISH = English.JobPostings?.BUTTON_PUBLISH || "Publish",
    TEXT_EMAIL = English.JobPostings?.BUTTON_EMAIL ,
    TEXT_POST_A_JOB = English.JobPostings?.TEXT_POST_A_JOB || "Post a job",
    TEXT_EMAIL_MISSING_PROFILE = English.JobPostings?.TEXT_EMAIL_MISSING_PROFILE || "Email is missing in your profile. Please update your email to receive applications.",
    TEXT_PUBLISH_FAILED = English.JobPostings?.TEXT_PUBLISH_FAILED || "Failed to publish the job post. Please try again.",
    TEXT_NO_ADDRESS = English.JobPostings?.TEXT_NO_ADDRESS || "No address available",
    TEXT_SKILLS_PLACEHOLDER = English.JobPostings?.TEXT_SKILLS_PLACEHOLDER || "Add the skills and qualifications you are looking for (recommended)",
    TEXT_ENTER_WEBSITE_URL = English.JobPostings?.TEXT_ENTER_WEBSITE_URL || "Enter website URL",
    TEXT_EXTERNAL_WEBSITE = English.JobPostings?.TEXT_EXTERNAL_WEBSITE || "Enter website URL",
    TEXT_INVALID_WEBSITE_URL = English.JobPostings?.TEXT_INVALID_WEBSITE_URL || "Please enter a valid website URL",
    TEXT_EMAIL_MISSING = English.JobPostings?.TEXT_EMAIL_MISSING || "Email missing"
  } = LanguageData || {};

  useEffect(() => {
    fetchJobPostTypes();
  }, []);

  useEffect(() => {
    if (chooseSite && chooseSite?.id) {
      setSelectedSite(chooseSite);
      dispatch(setChoosesite(null));
      dispatch(setSelectedsite(null));
    }
  }, [chooseSite]);

  const fetchJobPostTypes = useCallback(async () => {
    try {
      const obj = {
        PageNr: 1,
        NrOfRecPerPage: 20,
        FullSearch: "",
        UserId: userID,
        IncludeRecordNr: "true",
        TypeOfObjectReturned: "",
        FetchAllowedRecordsOnly: true,
        SearchList: [],
        SortList: [{}]
      };
      const res = await Postrequestcall(FETCH_JOB_POST_TYPES, obj, loginData?.accessToken);
      const resData = res?.data?.data || [];
      const updatedData = resData?.map((value) => {
        return { value: value.id, label: value.typeName, isChecked: false };
      });
      setTypeOptions(updatedData);
    } catch (error) {
      console.log("Error fetchJobPostTypes :: ", error);
    }
  }, [loginData]);

  const onTypeClick = (type) => {
    setSelectedTypeValue((preValue) => (type.value === preValue ? "" : type.value));
  };

  const onSelectTrades = (trades) => {
    setSelectedTrades(trades);
  };

  const onChooseSiteClick = () => {
    let mapModal = {
      open: true,
      from: "post-a-job",
      select: "add-site"
    };
    dispatch(setShowmapmodal(mapModal));
  };

  const handleSearch = (place) => {
    let lat = Number(place.geometry.location.lat());
    let lng = Number(place.geometry.location.lng());

    let address = "";
    let city = "";
    let province = "";

    if (place?.address_components.length > 0) {
      for (let i = 0; i < place?.address_components.length; i++) {
        let x = place?.address_components[i];
        if (x.types[0] === "street_number") address += x.long_name + " ";
        if (x.types[0] === "route") address += x.long_name + " ";
        if (x.types[0] === "locality" || x.types[0] === "postal_town") city = x.long_name;
        if (x.types[0] === "administrative_area_level_1") province = x.short_name;
      }
    }

    let _addressValue = city ? city + (province ? ", " + province : "") : address;
    setLocationDetails((preValue) => ({
      ...preValue,
      address: _addressValue,
      lat: lat,
      lng: lng
    }));
    setSearchTerm(_addressValue);
  };

  const onNextClick = () => {
    if (title.trim() === "" || !locationDetails?.lat || !locationDetails?.lng) {
      setShowRequiredError(true);
    } else {
      setShowRequiredError(false);
      setPage(2);
    }
    return;
  };

  const onPublishClick = async (e) => {
    try {
      e.preventDefault();
      if (submitLoading) return;
      if (receiveApplicationBy === "website") {
        const isValid = validateUrl(webSiteUrl.trim());
        if (!isValid) {
          setIsWebisiteUrlInValid(true);
          return;
        }
      }

      if (
        receiveApplicationBy === "email" &&
        (!loginData?.userInformation?.Email || loginData?.userInformation?.Email.trim() === "")
      ) {
        alert(
          TEXT_EMAIL_MISSING_PROFILE
        );
        return;
      }

      if (isWebisiteUrlInValid) {
        setIsWebisiteUrlInValid(false);
      }
      setSubmitLoading(true);

      let obj = {
        UserId: userID,
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: 0,
            Title: title.trim(),
            CompanyId: selectedCompany?.id || 0,
            Types: selectedTypeValue || "",
            Location: locationDetails?.address.trim(),
            Latitude: locationDetails?.lat || null,
            Longitude: locationDetails?.lng || null,
            SiteId: selectedSite?.id || 0,
            Trades: selectedTrades.map((trade) => trade.value).toString(),
            Description: description.trim() || "",
            ReceiveApplicantBy: receiveApplicationBy === "email" ? "EMAIL" : "WEBSITE",
            ReceiveApplicantLink:
              receiveApplicationBy === "email"
                ? loginData?.userInformation?.Email.trim()
                : webSiteUrl.trim(),
            ModifiedBy: userID
          }
        ]
      };

      await Postrequestcall(SAVE_JOB_POSTS_NEW, obj, loginData?.accessToken);
      onClose();
      onNewJobPostedSuccess();
    } catch (error) {
      console.log("Error onPublishClick :: ", error);
      alert(TEXT_PUBLISH_FAILED);
    } finally {
      setSubmitLoading(false);
    }
  };

  return (
    <>
      <Modal open={open}>
        <Box className="user-modal-responsive">
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between"
            }}>
            <Typography variant="h6" sx={{ fontSize: 18 }}>
              {page === 2 && (
                <IconButton onClick={() => setPage(1)}>
                  <ArrowBackIcon sx={{ color: "#000000" }} />
                </IconButton>
              )}
              {TEXT_POST_A_JOB} ({`${page}/2`})
            </Typography>
            <Stack flexDirection={"row"}>
              <IconButton onClick={onClose}>
                <CloseIcon />
              </IconButton>
            </Stack>
          </Box>

          <Stack flexDirection={"column"} gap={2} sx={{ mt: 2 }} justifyContent={"space-between"}>
            {page === 1 ? (
              <Box
                sx={{
                  overflow: "auto",
                  height: "450px"
                }}>
                <Stack>
                  <Typography sx={{ color: showRequiredError && !title?.trim() ? BIRed : BIGrey }}>
                    {TEXT_TITLE} *
                  </Typography>
                  <TextField
                    variant="outlined"
                    value={title}
                    onChange={(e) => {
                      setTitle(e.target.value);
                    }}
                    size="small"
                    placeholder={TEXT_ENTER_JOB_TITLE}
                    error={showRequiredError && !title?.trim()}
                  />
                </Stack>

                <Typography sx={{ mt: 2, color: BIGrey }}>{TEXT_COMPANY}</Typography>

                <Stack
                  direction={"row"}
                  justifyContent={"space-between"}
                  alignItems={"center"}
                  sx={{ border: `1px solid ${BILightGrey}`, borderRadius: "4px" }}>
                  <Stack
                    sx={{ cursor: "pointer" }}
                    onClick={() => {
                      setShowCompanyOptions(true);
                    }}>
                    <Typography sx={{ color: !selectedCompany?.id && BIGrey, pl: 1 }}>
                      {selectedCompany?.name || TEXT_SELECT_COMPANY}
                    </Typography>
                  </Stack>
                  {selectedCompany?.id && (
                    <IconButton
                      onClick={() => {
                        setSelectedCompany(null);
                      }}>
                      <CloseIcon />
                    </IconButton>
                  )}
                </Stack>

                <Stack sx={{ mt: 2 }}>
                  <Typography sx={{ color: BIGrey }}>{TEXT_TYPE}</Typography>
                  <Stack
                    direction={"row"}
                    alignItems={"center"}
                    flexWrap={"wrap"}
                    gap={1}
                    sx={{ mt: 0.5 }}>
                    {typeOptions?.map((type, i) => (
                      <Chip
                        label={type?.label || ""}
                        key={i}
                        onClick={() => {
                          onTypeClick(type);
                        }}
                        variant={type?.value == selectedTypeValue ? "filled" : "outlined"}
                        sx={{
                          backgroundColor:
                            type?.value == selectedTypeValue
                              ? lightenHexColor(BIBlue, 80)
                              : lightenHexColor(BIGrey, 90),
                          color: type?.value == selectedTypeValue ? BIBlue : "",
                          cursor: "pointer"
                        }}
                      />
                    ))}
                  </Stack>
                </Stack>

                <Stack sx={{ mt: 2 }}>
                  <Typography
                    sx={{ color: showRequiredError && !locationDetails?.lat ? BIRed : BIGrey }}>
                    {TEXT_LOCATION}
                  </Typography>

                  <SearchMap
                    setSearchTerm={(value) => {
                      if (value) {
                        setSearchTerm(value);
                      } else {
                        setSearchTerm("");
                        setLocationDetails({});
                      }
                      return;
                    }}
                    searchTerm={searchTerm}
                    handleSearch={handleSearch}
                    placeholder={TEXT_SEARCH_LOCATION}
                    from="jobposting"
                    error={showRequiredError && !locationDetails?.lat}
                  />
                </Stack>

                <Divider sx={{ mt: 2 }} />

                <Stack sx={{ mt: 1 }}>
                  <Stack
                    flexDirection={"row"}
                    justifyContent={"space-between"}
                    alignItems={"center"}>
                    <Stack>
                      <Typography>{TEXT_ADDITIONAL_INFORMATION}</Typography>
                      <Typography sx={{ color: BIGrey }}>
                        {TEXT_ADDITIONAL_INFORMATION_DESCRIPTION}
                      </Typography>
                    </Stack>
                    <IconButton onClick={() => setShowAdditionalInfo((preValue) => !preValue)}>
                      {showAdditionalInfo ? (
                        <KeyboardArrowDownIcon sx={{ color: "#000000" }} />
                      ) : (
                        <KeyboardArrowUpIcon sx={{ color: "#000000" }} />
                      )}
                    </IconButton>
                  </Stack>

                  {showAdditionalInfo && (
                    <>
                      <Typography sx={{ mt: 2, color: BIGrey }}>{TEXT_SITE}</Typography>
                      {selectedSite?.id ? (
                        <Stack
                          direction={"row"}
                          justifyContent={"space-between"}
                          alignItems={"center"}
                          sx={{ border: `1px solid ${BILightGrey}`, borderRadius: "4px", p: 1 }}>
                          <Stack>
                            <Typography>{selectedSite?.name}</Typography>
                            <Typography sx={{ color: BIGrey }}>
                              {selectedSite?.address || TEXT_NO_ADDRESS}
                            </Typography>
                          </Stack>
                          <IconButton
                            onClick={() => {
                              setSelectedSite(null);
                            }}>
                            <CloseIcon />
                          </IconButton>
                        </Stack>
                      ) : (
                        <Button
                          variant="contained"
                          sx={{ backgroundColor: lightenHexColor(BIGrey, 90), color: "black" }}
                          onClick={onChooseSiteClick}>
                          {TEXT_CHOOSE_SITE}
                        </Button>
                      )}

                      <Typography sx={{ mt: 2, color: BIGrey }}>{TEXT_TRADE}</Typography>
                      <Stack
                        sx={{
                          border: `1px solid ${BILightGrey}`,
                          borderRadius: "4px",
                          p: 1,
                          cursor: "pointer"
                        }}
                        justifyContent={"space-between"}
                        flexDirection={"row"}
                        alignItems={"center"}
                        onClick={() => setShowTradesModal(true)}>
                        <Stack direction={"row"} alignItems={"center"} flexWrap={"wrap"} gap={1}>
                          {selectedTrades?.map((type, i) => (
                            <Chip
                              label={type?.label || ""}
                              key={i}
                              onClick={() => {
                                onTypeClick(type);
                              }}
                              variant={"filled"}
                              sx={{
                                backgroundColor: lightenHexColor(BIGrey, 90),
                                cursor: "pointer"
                              }}
                            />
                          ))}
                        </Stack>
                        <EditIcon sx={{ color: BIGrey }} />
                      </Stack>
                    </>
                  )}
                </Stack>
              </Box>
            ) : (
              <Box
                sx={{
                  overflow: "auto",
                  height: "450px"
                }}>
                <Stack>
                  <Typography sx={{ color: BIGrey }}>{TEXT_DESCRIPTION}</Typography>
                  <TextField
                    variant="outlined"
                    value={description}
                    onChange={(e) => {
                      setDescription(e.target.value);
                    }}
                    multiline
                    size="small"
                    placeholder={TEXT_SKILLS_PLACEHOLDER}
                    rows={4}
                  />
                </Stack>

                <Divider sx={{ mt: 2 }} />

                <Stack sx={{ mt: 2 }}>
                  <Typography>{TEXT_RECEIVED_APPLICANTS}</Typography>
                  <Stack gap={1} sx={{ mt: 1 }}>
                    <Stack
                      direction={"row"}
                      alignItems={"center"}
                      gap={1}
                      sx={{
                        border: `1px solid ${BILightGrey}`,
                        borderRadius: "4px",
                        p: 0,
                        cursor: "pointer"
                      }}
                      onClick={() => {
                        setReceiveApplicationBy("email");
                      }}>
                      <Radio
                        checked={receiveApplicationBy === "email"}
                        onChange={() => {
                          setReceiveApplicationBy("email");
                        }}
                        value="email"
                        name="radio-buttons"
                        inputProps={{ "aria-label": "A" }}
                      />
                      <Typography>{TEXT_EMAIL}</Typography>
                    </Stack>
                    <Stack
                      direction={"row"}
                      alignItems={"center"}
                      gap={1}
                      sx={{
                        border: `1px solid ${BILightGrey}`,
                        borderRadius: "4px",
                        p: 0,
                        cursor: "pointer"
                      }}
                      onClick={() => {
                        setReceiveApplicationBy("website");
                      }}>
                      <Radio
                        checked={receiveApplicationBy === "website"}
                        onChange={() => {
                          setReceiveApplicationBy("website");
                        }}
                        value="email"
                        name="radio-buttons"
                        inputProps={{ "aria-label": "A" }}
                      />
                      <Typography>{TEXT_EXTERNAL_WEBSITE}</Typography>
                    </Stack>
                  </Stack>

                  <Stack sx={{ mt: 2 }}>
                    {receiveApplicationBy === "website" ? (
                      <>
                        <Typography
                          sx={{
                            color:
                              isWebisiteUrlInValid && !validateUrl(webSiteUrl.trim())
                                ? BIRed
                                : BIGrey
                          }}>
                          {TEXT_WEBSITE}
                        </Typography>
                        <TextField
                          variant="outlined"
                          value={webSiteUrl}
                          onChange={(e) => {
                            setWebSiteUrl(e.target.value);
                            if (isWebisiteUrlInValid) {
                              setIsWebisiteUrlInValid(!validateUrl(e.target.value.trim()));
                            }
                          }}
                          size="small"
                          placeholder={TEXT_ENTER_WEBSITE_URL}
                          error={isWebisiteUrlInValid && !validateUrl(webSiteUrl.trim())}
                          helperText={
                            isWebisiteUrlInValid && !validateUrl(webSiteUrl.trim())
                              ? TEXT_INVALID_WEBSITE_URL
                              : ""
                          }
                        />
                      </>
                    ) : (
                      <>
                        <Typography sx={{ color: BIGrey }}>{TEXT_EMAIL}</Typography>
                        <Typography
                          sx={{ border: `1px solid ${BILightGrey}`, borderRadius: "4px", p: 1 }}>
                          {loginData?.userInformation?.Email || TEXT_EMAIL_MISSING}
                        </Typography>
                      </>
                    )}
                  </Stack>
                </Stack>
              </Box>
            )}

            <Button
              variant="contained"
              onClick={(e) => {
                if (page === 1) {
                  onNextClick();
                } else {
                  onPublishClick(e);
                }
                return;
              }}>
              {submitLoading ? (
                <CircularProgress sx={{ color: "white" }} size={22} />
              ) : page === 1 ? (
                BUTTON_NEXT
              ) : (
                BUTTON_PUBLISH
              )}
            </Button>
          </Stack>
        </Box>
      </Modal>

      <FilterListModal
        open={showTradesModal}
        onClose={() => setShowTradesModal(false)}
        selectedTrades={selectedTrades}
        onSelectTrades={onSelectTrades}
        from="postAJob"
      />

      {showCompanyOptions && (
        <AddCompnayModal
          open={showCompanyOptions}
          onClose={() => setShowCompanyOptions(false)}
          from="post-a-job"
          onCompanySelect={(comp) => {
            setSelectedCompany(comp || null);
          }}
        />
      )}
    </>
  );
};

export default PostAJobModal;
